module.exports = __webpack_public_path__ + "static/media/edit_constraints_course_classrooms.c0b28527.mov";